module.exports = __webpack_public_path__ + "static/img/static/img/pre_close.c529fa8d.png";